import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  constructor(
    private _router: Router,
    private _utils: UtilsService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token: string = localStorage.getItem('token');

    let request = req;
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          if(err.url.split('seguridad-api')[1]!== undefined){
            if(err.url.split('seguridad-api')[1]=='/v1/api/authenticate'){
              console.log('Usuario o contraseña incorrectos');
              return throwError(err);
            }
          }
          // Endpoints públicos de recuperación/cambio de contraseña: se consumen SIN sesión activa,
          // por lo que un 401 aquí no debe forzar logout ni redirección global.
          if (req.url.includes('reset-password')) {
            return throwError(err);
          }
          //this._router.navigate(['login'], { queryParams: { returnUrl: req.url } });
          console.log('CADUCADO!');
          this._router.navigateByUrl('/login');
          localStorage.clear();
          window.location.href = window.location.origin;      
        }
        return throwError(err);
      })
    );
    if (token) {
      request = req.clone({
        setHeaders: {
          Authorization: localStorage.getItem('accessToken')
        }
      });
    }

    return next.handle(request).pipe(
      map(res => {
        console.log("Pasó por el interceptor en respuesta");
        return res
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this._router.navigateByUrl('/login');
          localStorage.clear();
          window.location.href = window.location.origin;
        }
        if (err.status === 403) {
          this._utils.mensajeErroToast('El usuario no cuenta con los permisos necesarios para visualizar esta información.', 5000);
          this._router.navigateByUrl('/home');
        }
        return throwError( err );
      })
    );
  }

}
